<template>
  <div class="base-lottie" ref="base-lottie"/>
</template>

<script>
import lottie from 'lottie-web'
export default {
  props: {
    path: {
      type: Object,
      required: true
    },
    loop: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.lottie = lottie.loadAnimation({
      container: this.$refs['base-lottie'],
      renderer: 'svg',
      loop: this.loop,
      autoplay: true,
      animationData: this.path
    })
  }
}
</script>

<style lang="scss" scoped>
.base-lottie {
  width: 100%;
  height: auto;
  position: relative;
}
::v-deep svg {
  width: 100%;
  height: auto;
  display: block;
  will-change: transform;
}
</style>
